import { Injectable } from '@angular/core';
import { createStore, select, withProps } from '@ngneat/elf';
import { AssetState } from './state/asset-state';
import { AddressUtil } from '@31third/common';

import { AllocationAsset, Asset, SimpleToken } from '../model';

const store = createStore(
  { name: 'assets' },
  withProps<AssetState>({
    assets: [],
    nativeAsset: undefined,
    setProtocolAssets: undefined,
  }),
);

@Injectable({ providedIn: 'root' })
export class AssetRepository {
  assets$ = store.pipe(select(({ assets }) => assets));
  assetsWithBalance$ = store.pipe(
    select(({ assets }) =>
      assets.filter(
        asset =>
          asset.balance !== undefined &&
          asset.balance !== null &&
          asset.balance > 0n,
      ),
    ),
  );
  // hardcoded for now
  aavePositionAssets$ = store.pipe(
    select(({ assets }) =>
      // USDC.e cannot be used as collateral in AaveV3 Polygon Market
      assets.filter(asset =>
        ['WETH', 'WBTC', 'USDT', 'USDC', 'wstETH'].includes(asset.token.symbol),
      ),
    ),
  );

  public get store() {
    return store;
  }

  public getAssetByTokenAddress(tokenAddress: string): Asset | undefined {
    return this.store
      .getValue()
      .assets?.find(asset =>
        AddressUtil.equals(asset.token.address, tokenAddress),
      );
  }

  /**
   * CAUTION: there might be duplicates
   * @param symbol
   */
  public getAssetByTokenSymbol(symbol: string): Asset | undefined {
    return this.store
      .getValue()
      .assets?.find(asset =>
        AddressUtil.equals(
          asset.token.symbol.toLowerCase(),
          symbol.toLowerCase(),
        ),
      );
  }

  public getTokenByAddress(tokenAddress: string): SimpleToken {
    const asset = this.getAssetByTokenAddress(tokenAddress);
    if (asset) {
      return asset.token;
    }
    const token = new SimpleToken();
    token.address = tokenAddress;
    token.name = 'Unknown';
    token.symbol = 'Unknown';
    token.decimals = 18;
    return token;
  }

  public getAssetsWithBalance(): Asset[] {
    return this.store
      .getValue()
      .assets?.filter(
        asset =>
          asset.balance !== undefined &&
          asset.balance !== null &&
          asset.balance > 0n,
      );
  }

  public setAssets(assets: Asset[]): void {
    store.next({ ...store.getValue(), assets });
  }

  public setNativeAsset(nativeAsset: Asset | undefined): void {
    store.next({ ...store.getValue(), nativeAsset });
  }

  // TODO: move to other lib
  public setSetProtocolAssets(setProtocolAssets: AllocationAsset[]): void {
    store.next({ ...store.getValue(), setProtocolAssets });
  }
}
